"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayInventoryNotification = exports.displayEstDeliveryDate = exports.displayRtiOosAccessoryMessage = exports.displayRtiOosDeviceMessage = exports.displayAvailabilityMessage = exports.qtyDetails = exports.isQtyDecrementRequired = exports.commonDeliveryMessage = void 0;
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var React = require("react");
var styles = require("./WirelessCart.scss");
var components_1 = require("@idp/duc/components");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var icons = require("../../../styles/ccc-icons-cart.scss");
var utils_1 = require("@idp/ui-components/utils");
var wlsCMS = wlsUtils.getWlsCmsData();
function commonDeliveryMessage(rtiCommonDeliveryText, payload) {
    var dividerStyle = cartUtils.isNewWirelessPostpaidView() ? styles.expupDivider : styles.solidLightGray;
    var messageStyle = Utils.isExpressUpgradeViewEnabled() ? [styles.rtiCommonDeliveryMessage,
        styles.rtiExpUpCommonMessage].join(' ') : styles.rtiCommonDeliveryMessage;
    var pageUrl = location.href;
    var isDisplay = Utils.isEnableValidateInventory() &&
        !cartUtils.isExpupgradeViewEnable() &&
        payload && payload.wirelessCart &&
        payload.wirelessCart.deliveryMethods &&
        payload.wirelessCart.deliveryMethods.length > 0 &&
        (((payload.wirelessCart.deliveryMethods.indexOf('C2S') !== -1 &&
            payload.wirelessCart.deliveryMethods.indexOf('DF') !== -1) ||
            (payload.wirelessCart.deliveryMethods.indexOf('ENJOY') !== -1 &&
                payload.wirelessCart.deliveryMethods.indexOf('DF') !== -1))
            && !(pageUrl.includes('buy/checkout/cartview')));
    return isDisplay &&
        (React.createElement("div", { className: messageStyle },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: rtiCommonDeliveryText || '' } }),
            React.createElement("div", { className: [dividerStyle, styles.activationLineItem].join(' ') })));
}
exports.commonDeliveryMessage = commonDeliveryMessage;
function isQtyDecrementRequired(lineItem) {
    var isDecrement = false;
    // tslint:disable-next-line: no-any
    var matchedValues = [];
    if (lineItem && lineItem.fulfillmentOptionsView && lineItem.fulfillmentOptionsView.skuFulfillmentInfos) {
        lineItem.fulfillmentOptionsView.skuFulfillmentInfos.forEach(function (items) {
            if (items && items.qtyDecrementRequired) {
                matchedValues.push(items.qtyDecrementRequired);
            }
        });
        if (matchedValues && matchedValues.length > 0) {
            isDecrement = true;
        }
    }
    return isDecrement;
}
exports.isQtyDecrementRequired = isQtyDecrementRequired;
function qtyDetails(lineItem) {
    var qtyInfo;
    // tslint:disable-next-line: no-any
    var matchedValues = [];
    if (lineItem && lineItem.fulfillmentOptionsView && lineItem.fulfillmentOptionsView.skuFulfillmentInfos) {
        lineItem.fulfillmentOptionsView.skuFulfillmentInfos.forEach(function (items) {
            if (items && items.qtyDecrementRequired) {
                if (items.qtyDiff && items.fulfillmentMethod === 'DF') {
                    qtyInfo = { qtyDiff: items.qtyDiff };
                }
                if (items && items.removeItem) {
                    matchedValues.push(items.removeItem);
                }
            }
        });
        if (matchedValues && matchedValues.length > 0) {
            qtyInfo = __assign(__assign({}, qtyInfo), { removeItem: true });
        }
    }
    return qtyInfo;
}
exports.qtyDetails = qtyDetails;
function displayAvailabilityMessage(lineItem, payload) {
    var message;
    var isDF = false;
    var isC2S = false;
    var isCommon = wlsUtils.isCommonDeliveryMethodAvailable(payload);
    if (Utils.unauthenticatedAccess()) {
        return (React.createElement(React.Fragment, null));
    }
    else if (lineItem && lineItem.fulfillmentOptionsView && Utils.isEnableValidateInventory() &&
        !wlsUtils.isRTIOSSDevice(payload)) {
        if (lineItem.fulfillmentOptionsView.skuFulfillmentInfos) {
            lineItem.fulfillmentOptionsView.skuFulfillmentInfos.forEach(function (items) {
                if (items.available === true && items.fulfillmentMethod === 'DF') {
                    isDF = true;
                }
                else if (items.available === true && items.fulfillmentMethod === 'C2S') {
                    isC2S = true;
                }
            });
        }
        if (!isCommon) {
            if (isDF && !isC2S) {
                message = wlsCMS.rtiShippingText;
            }
            else if (!isDF && isC2S) {
                message = wlsCMS.rtiPickupText;
            }
        }
        else {
            if (!isDF && isC2S) {
                message = wlsCMS.rtiC2Stext;
            }
        }
        return message && (React.createElement("div", { className: [styles.limitedQtyMessage, styles.displayFlex].join(' ') },
            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCart2x,
                    icons.cccIconCartAlert, styles.realtimeInventoryWarn, styles.rtiShippingText].join(' '), "aria-hidden": "true" }),
            React.createElement("span", null, message)));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
exports.displayAvailabilityMessage = displayAvailabilityMessage;
function displayRtiOosDeviceMessage(losg, losgsCount, 
// tslint:disable-next-line: no-any
editLineForPscCustomers, removeLineForPscCustomers, deviceLable, showEditOptions, payload, editUrl) {
    var displayMessage;
    if (payload && payload.wirelessCart && Utils.isEnableValidateInventory()) {
        var losgItems = wlsUtils.organizeLineItems(Object.values(losg.lineItems), payload.wirelessCart.mixAndMatch, losg);
        var displayLabel_1;
        var errorText_1;
        var iconClasses_1 = [icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartBadgealert,
            styles.rtiDeviceErrorIcon];
        var pickDeviceLabel_1 = editUrl && (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('WirelessCart', 'Link', 'pick up another device'), 
            // tslint:disable-next-line: jsx-no-lambda
            onClick: function () {
                editLineForPscCustomers(editUrl);
            } }, wlsCMS.pickDeviceLabel || 'pick another device'));
        displayMessage = losgItems.map(function (lineItem, secindex) {
            var keyId = "deviceInfo" + losg.id + "_" + secindex;
            var removeDeviceLabel = (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('WirelessCart', 'Link', 'remove line'), 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    removeLineForPscCustomers(losg.id || '', lineItem, losg, payload.wirelessCart.qualifierPlanName || '', losgsCount);
                } }, wlsCMS.removeItemLabel || ''));
            if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'DEVICE' &&
                isQtyDecrementRequired(lineItem)) {
                if (showEditOptions && deviceLable && pickDeviceLabel_1) {
                    errorText_1 = wlsCMS.deviceOOSText1;
                    displayLabel_1 = deviceLable && (React.createElement("span", null,
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + errorText_1.replace('{0}', '') } }),
                        deviceLable,
                        " or ",
                        pickDeviceLabel_1,
                        "."));
                }
                else if (pickDeviceLabel_1 && removeDeviceLabel) {
                    errorText_1 = wlsCMS.deviceOOSText;
                    displayLabel_1 = (React.createElement("span", null,
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + errorText_1.split('{0}')[0] } }),
                        pickDeviceLabel_1,
                        " or ",
                        removeDeviceLabel,
                        " ",
                        errorText_1.split('{0}')[1]));
                }
                var rtiTextStyle = Utils.isExpressUpgradeViewEnabled() ? [styles.rtiErrorMessageLines,
                    styles.rtiExpUpErrorMessage] : [styles.rtiErrorMessageLines];
                return displayLabel_1 && (React.createElement("div", { key: keyId, className: rtiTextStyle.join(' ') },
                    React.createElement("i", { className: iconClasses_1.join(' '), role: "img", "aria-label": "Error", tabIndex: 0 }),
                    displayLabel_1));
            }
            else {
                return (React.createElement(React.Fragment, { key: keyId }));
            }
        });
    }
    return displayMessage;
}
exports.displayRtiOosDeviceMessage = displayRtiOosDeviceMessage;
function displayRtiOosAccessoryMessage(lineItem, losg, 
// tslint:disable-next-line: no-any
editLineForPscCustomers, changeAccessoryQuantity, editUrl, accOnly) {
    if (Utils.unauthenticatedAccess()) {
        return (React.createElement(React.Fragment, null));
    }
    else {
        var pickAccessoryLabel = (editUrl) && (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Wirelesscart', 'Link', 'pick another accessory'), 
            // tslint:disable-next-line: jsx-no-lambda
            onClick: function () {
                editLineForPscCustomers(editUrl);
            } }, wlsCMS.pickAccessoryLabel || ''));
        var iconClasses = [icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartBadgealert,
            styles.rtiDeviceErrorIcon];
        var displayLabel = void 0;
        var displayErrorLabel = [];
        var removeAccessoryabel = (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Wirelesscart', 'Link', 'remove item'), 
            // tslint:disable-next-line: jsx-no-lambda
            onClick: function () {
                accOnly ? changeAccessoryQuantity(0, losg, lineItem) :
                    changeAccessoryQuantity(0, losg.id, lineItem, losg.losgType, losg);
            } }, wlsCMS.removeItemLabel || ''));
        if (Utils.isEnableValidateInventory() &&
            lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'ACCESSORY'
            && isQtyDecrementRequired(lineItem)) {
            var errorCms = wlsCMS.deviceOOSText;
            var limitQtyMessage = wlsCMS.accessoryOOSText;
            var qtyInfo = qtyDetails(lineItem);
            var isOOSDevice = qtyInfo && qtyInfo.removeItem ? qtyInfo.removeItem : false;
            var qtyDiff = qtyInfo && qtyInfo.qtyDiff && qtyInfo.qtyDiff > 0 ? qtyInfo.qtyDiff : 0;
            var errorMessage = isOOSDevice ? (React.createElement("span", null,
                React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + errorCms.split('{0}')[0] } }),
                pickAccessoryLabel,
                " or ",
                removeAccessoryabel,
                " ",
                errorCms.split('{0}')[1])) : qtyDiff !== 0 ? (React.createElement("span", null,
                React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + limitQtyMessage.split('{0}')[0] } }),
                qtyDiff,
                " ",
                limitQtyMessage.split('{0}')[1],
                ".")) : React.createElement(React.Fragment, null);
            var rtiTextStyle = Utils.isExpressUpgradeViewEnabled() ? [styles.rtiErrorMessageLines,
                styles.rtiExpUpErrorMessage] : [styles.rtiErrorMessageLines];
            displayLabel = errorMessage ? (React.createElement("div", { className: rtiTextStyle.join(' ') },
                React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": "Error", tabIndex: 0 }),
                errorMessage)) : React.createElement(React.Fragment, null);
            displayErrorLabel.push(displayLabel);
        }
        return displayErrorLabel;
    }
}
exports.displayRtiOosAccessoryMessage = displayRtiOosAccessoryMessage;
function displayEstDeliveryDate(lineItem, expupEstDateLabel, isEditCapacity) {
    var estimatedDates;
    if (Utils.unauthenticatedAccess()) {
        return '';
    }
    else {
        var isPrePreOrder = cartUtils.isPrePreOrder();
        if (Utils.isEnableValidateInventory() && lineItem && lineItem.fulfillmentOptionsView &&
            lineItem.fulfillmentOptionsView.skuFulfillmentInfos && !(wlsUtils.isBYODAndEsim()) && !isPrePreOrder) {
            lineItem.fulfillmentOptionsView.skuFulfillmentInfos.forEach(function (items) {
                if (items && items.dates && items.dates.deliveryDates &&
                    items.dates.deliveryDates.dateFrom && items.dates.deliveryDates.dateTo) {
                    if (items.dates.deliveryDates.dateFrom === items.dates.deliveryDates.dateTo) {
                        estimatedDates = ((!isEditCapacity) ? expupEstDateLabel : '') + "\n                 " + items.dates.deliveryDates.dateFrom.split(',')[0] || '';
                    }
                    else {
                        estimatedDates = ((!isEditCapacity) ? expupEstDateLabel : '') + "\n                " + items.dates.deliveryDates.dateFrom.split(',')[0] + " -\n                " + items.dates.deliveryDates.dateTo.split(',')[0] || '';
                    }
                }
            });
        }
        return estimatedDates || '';
    }
}
exports.displayEstDeliveryDate = displayEstDeliveryDate;
function displayInventoryNotification(lineItem) {
    if (Utils.unauthenticatedAccess()) {
        return '';
    }
    if (lineItem && lineItem.fulfillmentOptionsView) {
        var message = wlsUtils.displayStatusMessage(lineItem.fulfillmentOptionsView);
        return message && (React.createElement("div", { className: styles.limitedQtyMessage },
            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartBadgealert, styles.realtimeInventoryWarn].join(' '), role: "img", "aria-label": "Warn", tabIndex: 0 }),
            React.createElement("span", null,
                " ",
                message || '')));
    }
    return '';
}
exports.displayInventoryNotification = displayInventoryNotification;
//# sourceMappingURL=WirelessRTI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessRTI.js
// module id = 173
// module chunks = 8